import { render, staticRenderFns } from "./rollGenerate.vue?vue&type=template&id=365598b5&scoped=true&"
import script from "./rollGenerate.vue?vue&type=script&lang=js&"
export * from "./rollGenerate.vue?vue&type=script&lang=js&"
import style0 from "./rollGenerate.vue?vue&type=style&index=0&id=365598b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365598b5",
  null
  
)

export default component.exports